import * as types from "./actionTypes";

export const fetchPersons = () => ({
  type: types.FETCH_PERSONS
});

export const fetchFilterPersons = letter => ({
  type: types.FETCH_FILTER_PERSONS,
  letter
});

export const fetchPersonsSuccess = result => ({
  type: types.FETCH_PERSONS_SUCCESS,
  result
});

export const fetchPersonsFinish = () => ({
  type: types.FETCH_PERSONS_FINISH
});

export const fetchPersonsError = error => ({
  type: types.FETCH_PERSONS_FAIL,
  error
});

export const clearPersons = () => ({
  type: types.CLEAR_PERSONS
});



// WEBPACK FOOTER //
// ./src/modules/persons/actions.js